import React from "react";

import { Icon } from "./components";
import { ControlProps } from "./types";
import { useControl } from "./hooks";

export const Control = (props: ControlProps) => {
  const { getButtonProps, values } = useControl(props);
  return (
    <button {...getButtonProps()}>
      <Icon type={props.type} />
      <span>{values.text}</span>
    </button>
  );
};
